// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3gEvm","description":"PatientConsentPreview_description__31Ycg"};